module.exports = __webpack_public_path__ + "static/media/Switch_to_aiva.74a940af.png";